import { render, staticRenderFns } from "./SwitchMap.vue?vue&type=template&id=22692cb1&"
import script from "./SwitchMap.vue?vue&type=script&lang=js&"
export * from "./SwitchMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports